import { Column, ColumnStore } from '@bryntum/schedulerpro';
import {$t} from "../../i18Instance";

/**
 * Zeigt die erwartete Verfügbarkeit der Bikes
 */
export class RmsObjectsGridColumnExpectedReturn extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'expectedReturnDate';
    }

    // Override default values
    static get defaults() {
        return {
            field: 'expectedReturnDate',
            align: 'center',
            editor: false,
            htmlEncode: false,
            renderer({ record, value, cellElement, row, size }) {
                return record.expectedReturnDate
                    ? moment(record.expectedReturnDate).format(AshnetApp.dateTimeFormat)
                    : ''; // Hier könnte auch ein Text stehen, wenn es verfügbar ist: //: $t('requests.grid.available');

            },
            tooltipRenderer: ({ record }) => {
                if (record.expectedReturnDate) {
                    //return `<div>${$t('requests.grid.not-available-until')} ${moment(record.expectedReturnDate).format(AshnetApp.dateTimeFormat)}</div>`;
                    return "<div>" + $t('objects.grid.expected-return') + "</div><div class='small'>" + $t('requests.grid.not-available-until') + "</div>";
                }
            }
        };
    }
};

ColumnStore.registerColumnType(RmsObjectsGridColumnExpectedReturn);
